import type { Nullable } from "vite-node"
import { ELEVATION_ABSOLUTE_MIN } from "../../../core/entity/EntityElevation/elevation_consts"
import isEntityHasFloorElevation from "../../../core/entity/EntityElevation/isEntityHasFloorElevation"
import type { Entity } from "../../../core/entity/index"
import isEntityWater from "../../../core/entity/isEntityWater"

// I use this one for placing the meshes
export default function getTerrainMesh1TileWaterElevationV1(ent: Nullable<Entity>): number {
  if (ent) {
    if (isEntityWater(ent)) {
      return ent.water_e ?? ELEVATION_ABSOLUTE_MIN
    }
    if (isEntityHasFloorElevation(ent)) {
      // return ent.floor_e
      return ent.floor_e - 1.9
    }
    // if (isEntityHasWaterElevation(ent)) {
    //   return ent.water_e
    // }
    // if (isEntityHasFloorElevation(ent)) {
    //   return ent.floor_e
    // }
    // if (isEntityHasElevation(ent)) {
    //   return ent.elevation
    // }
  }
  return ELEVATION_ABSOLUTE_MIN
}